import React from 'react';
import Dropdown from "../../Dropdown";

import { InsertChart, ChevronDown, Tools, Book, Star, PeopleGroup } from "../../../icons";
import Button from "../../Button";
import { adminRights, celticsRights } from "../../../utils/accessRights";

import { HeaderLinksRoutes } from "../index";
import { createStyles } from "./styles";
import ToolsDropdownOption from "../ToolsDropdownOption";






var ToolsDropdown = function ToolsDropdown(_ref) {var customMainColor = _ref.customMainColor,currentUserRoles = _ref.currentUserRoles;
  var classes = createStyles({ customMainColor: customMainColor });

  // Common data

  // Options for all user roles
  var FavoriteProposalOption = {
    value: HeaderLinksRoutes.FAVORITE_PROPOSALS,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(ToolsDropdownOption, {
          key: key,
          href: HeaderLinksRoutes.FAVORITE_PROPOSALS,
          icon: /*#__PURE__*/React.createElement(Star, null),
          linkText: "Favorite Proposals",
          customMainColor: customMainColor }));}


  };

  var BiDashboardOption = {
    value: HeaderLinksRoutes.BI_DASHBOARD,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(ToolsDropdownOption, {
          key: key,
          href: HeaderLinksRoutes.BI_DASHBOARD,
          icon: /*#__PURE__*/React.createElement(PeopleGroup, null),
          linkText: "BI Dashboard",
          customMainColor: customMainColor }));}


  };

  // Options only for admin and celtics
  var AdminToolDropdownOptions = [
  {
    value: HeaderLinksRoutes.BOOK_OF_BUSINESS,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(ToolsDropdownOption, {
          key: key,
          href: HeaderLinksRoutes.BOOK_OF_BUSINESS,
          icon: /*#__PURE__*/React.createElement(Book, { width: "3.2rem" }),
          linkText: "Book Of Business",
          customMainColor: customMainColor }));}


  },
  {
    value: HeaderLinksRoutes.INSIGHTS,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(ToolsDropdownOption, {
          key: key,
          href: HeaderLinksRoutes.INSIGHTS,
          icon: /*#__PURE__*/React.createElement(InsertChart, null),
          linkText: "Insights",
          customMainColor: customMainColor }));}


  }];


  var ToolsButton = /*#__PURE__*/
  React.createElement(Button, {
    type: "text",
    leftIconProp: /*#__PURE__*/React.createElement(Tools, null),
    rightIconProp: /*#__PURE__*/React.createElement(ChevronDown, null),
    size: "small",
    className: classes.dropdownButton }, "Tools");





  // Component actions
  function createUserDropdownOptions() {
    var resultOptions = [];
    resultOptions.push(FavoriteProposalOption);
    if (adminRights(currentUserRoles)) {
      resultOptions.push.apply(resultOptions, AdminToolDropdownOptions);
    }
    if (celticsRights(currentUserRoles)) {
      resultOptions.push(BiDashboardOption);
    }
    return resultOptions;
  }

  return /*#__PURE__*/(
    React.createElement(Dropdown, {
      name: "tools",
      className: classes.toolDropdown,
      options: createUserDropdownOptions(),
      openedElement: ToolsButton,
      closedElement: ToolsButton }));


};

export default ToolsDropdown;
//# sourceMappingURL=index.js.map